module.exports = __webpack_public_path__ + "static/media/dundercastel-69_Small.46c487ba.jpg";